export default __webpack_public_path__ + "static/1-4ff2dcd2dfa604258f6976ed7ad892cc.gif";